export default function PHP_getprotobyname() {
  return (
    <div>
      <h1>PHP_getprotobyname</h1>
    </div>
  );
}
